import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Translation, TranslocoLoader } from '@ngneat/transloco';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TranslocoHttpLoader implements TranslocoLoader {
  private readonly _httpClient: HttpClient = inject(HttpClient);

  public getTranslation(lang: string, data?: { scope: string }): Observable<Translation> {
    return this._httpClient.get<Translation>(`./i18n/${lang}/${data?.scope || 'root'}.json`);
  }
}
